module.exports = __webpack_public_path__ + "static/fonts/Fact-Bold.5ce169e.ttf";